<div>
    <div class="d-flex justify-content-center align-content-center my-2">
        <div class="rating-star">
            <span class="fa fa-star" [ngClass]="rating >= star ? 'checked': ''"  *ngFor="let star of [1,2,3,4,5]" (click)="starClicked(star)"></span>
        </div>
    </div>
    <div class="d-flex justify-content-center align-content-center my-4" *ngIf="!isReviewFormActive">
        <button type="submit" class="btn-q5 btn-outline-primary-q5" (click)="toggleReviewform()">Write Review</button>
    </div>
    <div class="review-container" [ngClass]="isReviewFormActive ? 'active':''">
        <div class="d-flex flex-column justify-content-center align-content-center my-4" *ngIf="isReviewFormActive">
            <form [formGroup]="reviewForm" (submit)="submitReview()">
                <div class="m-4">
                    <input formControlName="title" type="text" placeholder="Review title" autocomplete="off" class="input-field">
                </div>
                <div class="m-4">
                    <textarea formControlName="desc" placeholder="Description" autocomplete="off" class="text-area-q5"></textarea>
                </div>
                <div class="d-flex justify-content-center align-content-center">
                    <button class="btn-q5 btn-outline-secondary-q5 mr-3"
                        (click)="toggleReviewform()">Cancel</button>
                    <button type="submit" class="btn-q5 btn-primary-q5">Submit Review</button>
                </div>
            </form>
        </div>
    </div>
</div>